<div class="container">
  <div class="loading-overlay" *ngIf="loading">
    <mat-progress-spinner mode="indeterminate" diameter="40" strokeWidth="3"></mat-progress-spinner>
  </div>

  <form class="card-form" [formGroup]="dpForm" (ngSubmit)="submitForm()" autocomplete="off" novalidate>
    <div class="blue-top">
      <img class="blue-top-logo" src="app/assets/icea-logo.png" alt="ICEA LION" />
      <span class="blue-top-title">Home Insurance Details</span>

    </div>

    <div class="card-section top-section">
      <h2>Enter personal details</h2>
      <p class="section-hint">Please enter your personal details below</p>

      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">Full name</mat-label>
        <input matInput formControlName="fullName" (blur)="logErrors()">
        <mat-icon matSuffix *ngIf="isOcrLocked('fullName')" title="Extracted from your ID document">lock</mat-icon>
        <mat-error *ngIf="formErrors['fullName']">{{formErrors['fullName']}}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">Email address</mat-label>
        <input matInput formControlName="email" inputmode="email" (blur)="logErrors()">
        <mat-error *ngIf="formErrors['email']">{{formErrors['email']}}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">Phone number</mat-label>
        <input matInput formControlName="phoneNumber" inputmode="tel" (blur)="logErrors()">
        <mat-error *ngIf="formErrors['phoneNumber']">{{formErrors['phoneNumber']}}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">Select identification type</mat-label>
        <mat-select formControlName="idType" panelClass="form-select-popup" (blur)="logErrors()" (selectionChange)="updateID()">
          <mat-option class="form-option" [value]="opt" *ngFor="let opt of IdTypePlaceHolders">
            {{opt}}
          </mat-option>
        </mat-select>
        <mat-icon matSuffix *ngIf="isOcrLocked('idType')" title="Extracted from your ID document">lock</mat-icon>
        <mat-error *ngIf="formErrors['idType']">{{formErrors['idType']}}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-select" *ngIf="selectedIdType && selectedIdType.length > 2">
        <mat-label class="form-select-placeholder-unselected">Enter {{selectedIdType | lowercase}}</mat-label>
        <input matInput [maxlength]="maxIDNUMLength" spellcheck="false" formControlName="idNumber" (blur)="logErrors()">
        <mat-icon matSuffix *ngIf="isOcrLocked('idNumber')" title="Extracted from your ID document">lock</mat-icon>
        <mat-error *ngIf="formErrors['idNumber']">{{formErrors['idNumber']}}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">KRA PIN</mat-label>
        <input matInput type="text" maxlength="11" spellcheck="false" formControlName="kraPin" (blur)="logErrors()">
        <mat-icon matSuffix *ngIf="isOcrLocked('kraPin')" title="Extracted from your KRA certificate">lock</mat-icon>
        <mat-error *ngIf="formErrors['kraPin']">{{formErrors['kraPin']}}</mat-error>
      </mat-form-field>

      <div class="row-div margin-top-50">
        <button mat-stroked-button type="button" (click)="confirmCancel()">
          <span class="button-text">Cancel</span>
        </button>
        <button mat-button type="submit" [disabled]="!dpForm.valid">
          <span class="button-text">Save and Continue</span>
        </button>
      </div>
    </div>
  </form>
</div>
